export const environment = {
  envName: 'development',
  production: false,
  apiBaseUrl: '/api',
};
